export default __webpack_public_path__ + "static/media/rating_10.9f7c62de.png";